import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconChevronRightRound = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <g clipPath="url(#icon-chevron-right-round__a)">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m10 6 6 6-6 6"
        vectorEffect="non-scaling-stroke"
      />
    </g>
    <defs>
      <clipPath id="icon-chevron-right-round__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
const Memo = memo(SvgIconChevronRightRound);
export default Memo;
